import React from 'react';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { useEarningsInsightsFilter } from '~/react-query-hooks/insights/useEarningsInsightsFilter';
import { parseEarningsInsights } from '~/react-query-hooks/insights/useEarningsInsightsFilter.utils';
import { queryKeys } from '~/routes/query-params';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { useSubscription } from '~/stores/use-subscription/useSubscription';
import { EarningsInsightIcon } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/earnings-insight-icon/EarningsInsightIcon';

import { DateCell, DateCellProps } from './DateCell';
import styles from './DateCellWithEarningsInsight.module.scss';

export const DateCellWithEarningsInsight = ({
  earningsId,
  ...rest
}: DateCellProps & { earningsId: string }) => {
  const isBasicOrLightUser = useSubscription(state =>
    state.isBasicOrLightUser()
  );
  const { params } = useQueryParams();
  const entityTag = params[queryKeys.assetOverviewAsset];

  const { data = [] } = useEarningsInsightsFilter({
    body: { earnings_ids: [earningsId] },
    isEnabled: !isBasicOrLightUser && !!earningsId,
  });
  const earningsInsight = parseEarningsInsights(data);

  return (
    <div className={styles.root}>
      <DateCell {...rest} />
      {!!earningsInsight && entityTag && (
        <EarningsInsightIcon
          entityTag={entityTag}
          size={28}
          earningsInsight={earningsInsight}
          source={POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW}
        />
      )}
    </div>
  );
};
